export default {
  th: {
    cardContest: {
      tab: {
        new_events: "กิจกรรมการแข่งขันใหม่",
        previous_events: "กิจกรรมการแข่งขันที่ผ่านมา",
      },
      status: {
        opening: "กำลังเปิดรับสมัคร",
        upcoming: "เร็วๆ นี้",
        ended: "การแข่งขันสิ้นสุดแล้ว",
      },
      button: {
        get_start: "เริ่มต้น",
        view_more: "ดูเพิ่มเติม",
        learn_more: "เรียนรู้เพิ่มเติม",
      },
      date: "วันที่",
      participant: "ผู้เข้าร่วม",
    },
  },
  lo: {},
  en: {
    cardContest: {
      tab: {
        new_events: "New Events",
        previous_events: "Previous Events",
      },
      status: {
        opening: "Opening",
        upcoming: "Upcoming",
        ended: "Ended",
      },
      button: {
        get_start: "Get Started",
        view_more: "View more",
        learn_more: "Learn more",
      },
      date: "Date",
      participant: "Participants",
    },
  },
  hi: {},
  ms: {
    cardContest: {
      tab: {
        new_events: "Peristiwa baharu",
        previous_events: "Peristiwa sebelumn ya",
      },
      status: {
        opening: "Pembukaa n",
        upcoming: "Akan datang",
        ended: "Berakhir",
      },
      button: {
        get_start: "Mulakan",
        view_more: "Lihat lagi",
        learn_more: "Ketahui lebih lanjut",
      },
      date: "Tarikh",
      participant: "Peserta",
    },
  },
  id: {
    cardContest: {
      tab: {
        new_events: "Acara baru",
        previous_events: "Acara sebelumn ya",
      },
      status: {
        opening: "Pembuka an",
        upcoming: "Mendata ng",
        ended: "Berakhir",
      },
      button: {
        get_start: "Mulai",
        view_more: "Lihat selengka pnya",
        learn_more: "Pelajari lebih lanjut",
      },
      date: "Tanggal",
      participant: "Peserta",
    },
  },
  zh: {
    cardContest: {
      tab: {
        new_events: "新活动",
        previous_events: "先前活动",
      },
      status: {
        opening: "开幕",
        upcoming: "即将举行",
        ended: "已结束",
      },
      button: {
        get_start: "开始",
        view_more: "查看更多",
        learn_more: "了解更多",
      },
      date: "日期",
      participant: "参与者",
    },
  },
  vi: {
    cardContest: {
      tab: {
        new_events: "Sự kiện mới",
        previous_events: "Sự kiện trước đó",
      },
      status: {
        opening: "Các ứng dụng hiện đang mở.",
        upcoming: "Sắp diễn ra",
        ended: "Cuộc thi đã kết thúc.",
      },
      button: {
        get_start: "Bắt đầu",
        view_more: "Xem thêm",
        learn_more: "Tìm hiểu thêm",
      },
      date: "Ngày",
      participant: "Người tham gia",
    },
  },
  ko: {},
  fil: {},
  ja: {
    cardContest: {
      tab: {
        new_events: "新しいイベント",
        previous_events: "過去のイベント",
      },
      status: {
        opening: "オープニング",
        upcoming: "今後のイベント",
        ended: "終了",
      },
      button: {
        get_start: "スタートする",
        view_more: "もっと見る",
        learn_more: "詳細を見る",
      },
      date: "日付",
      participant: "参加者",
    },
  },
  es: {
    cardContest: {
      tab: {
        new_events: "Nuevos Eventos",
        previous_events: "Eventos Anteriores",
      },
      status: {
        opening: "Apertura",
        upcoming: "Próximam ente",
        ended: "Finalizado",
      },
      button: {
        get_start: "Comenzar",
        view_more: "Ver Más",
        learn_more: "Aprender más",
      },
      date: "Fecha",
      participant: "Participante",
    },
  },
  pt: {
    cardContest: {
      tab: {
        new_events: "Novos Eventos",
        previous_events: "Eventos Anteriores",
      },
      status: {
        opening: "Em Andamento",
        upcoming: "Em Breve",
        ended: "Encerrado",
      },
      button: {
        get_start: "Começar",
        view_more: "Ver mais",
        learn_more: "Saiba mais",
      },
      date: "Data",
      participant: "Participantes",
    },
  },
};
